import React, { createContext } from "react";
import { languageOptions, dictionaryList } from "../components/Languages";

export const LanguageStore = createContext({
  language: languageOptions[0],
  dictionary: dictionaryList[languageOptions[0].id],
});
